import React from "react";
import { EmailIcon } from "./EmailIcon.tsx";
import styles from "./Login.module.css";

export const PasswordlessConfirmation: React.FC<{
  email: string;
  onTryDifferentEmail: () => void;
}> = ({ email, onTryDifferentEmail }) => {
  return (
    <div className={styles.PasswordlessContainer}>
      <div className={styles.ConfirmationContent}>
        <div className={styles.EmailIcon}>
          <EmailIcon />
        </div>

        <div className={styles.ConfirmationHeader}>
          <h2 className={styles.ConfirmationTitle}>Check your email</h2>
          <p className={styles.ConfirmationSubtitle}>
            We've sent a sign-in link to:
          </p>
        </div>

        <div className={styles.EmailDisplay}>{email}</div>

        <div className={styles.NextSteps}>
          <h3 className={styles.NextStepsTitle}>What's next?</h3>
          <ol className={styles.NextStepsList}>
            <li>Check your email inbox (and spam folder)</li>
            <li>Click the sign-in link in the email</li>
            <li>You'll be automatically signed in!</li>
          </ol>
        </div>

        <div className={styles.AdditionalInfo}>
          <p className={styles.SecurityNote}>
            The link will work on any device. If you open it on a different
            device, you may need to enter your email again for security.
          </p>
          <button
            className={styles.TryDifferentEmailLink}
            onClick={onTryDifferentEmail}
          >
            Try a different email
          </button>
        </div>
      </div>
    </div>
  );
};
